import React from "react";

const LinkWithIcon = ({ to, icon, label, ...rest }) => {
  return (
    <a {...rest} href={to} target="_blank">
      {icon}{" "}
      <span className="ml-1" style={{ fontWeight: 600 }}>
        {label}
      </span>
    </a>
  );
};

export default LinkWithIcon;
